import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { QrCode, Search, LogOut as CheckOutIcon } from "lucide-react";
import { formatDateTimeIST } from "@/lib/formatUtils";

export function QrCheckoutBar({ qrInput, setQrInput, onLookup }) {
  return (
    <Card className="mt-3 p-2.5 sm:p-3 bg-emerald-50/50 border-emerald-200">
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
        <div className="flex items-center gap-2 shrink-0">
          <QrCode size={20} className="text-emerald-700 shrink-0" />
          <span className="text-xs sm:text-sm font-semibold text-emerald-800 shrink-0">Quick Checkout:</span>
        </div>
        <div className="flex gap-2 flex-1">
          <Input
            value={qrInput}
            onChange={e => setQrInput(e.target.value)}
            onKeyDown={e => e.key === "Enter" && onLookup()}
            placeholder="Scan QR or enter GP No."
            className="h-9 flex-1 bg-white text-sm"
            data-testid="qr-checkout-input"
          />
          <Button onClick={onLookup} className="h-9 bg-emerald-700 hover:bg-emerald-800 text-xs shrink-0" data-testid="qr-lookup-btn">
            <Search size={14} className="sm:mr-1" /> <span className="hidden sm:inline">Lookup</span>
          </Button>
        </div>
      </div>
    </Card>
  );
}

export function QrCheckoutDialog({ open, onClose, result, onCheckout }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md" data-testid="qr-checkout-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "Chivo" }}>Gate Pass Checkout</DialogTitle>
        </DialogHeader>
        {result && (
          <div className="space-y-3">
            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
              <div className="text-lg font-black tracking-wider text-[#1B3C87] text-center mb-2">{result.gate_pass_no || "No GP"}</div>
              <div className="grid grid-cols-2 gap-2 text-sm">
                <div><span className="text-gray-500">Name:</span> <strong>{result.visitor_name}</strong></div>
                <div><span className="text-gray-500">Company:</span> {result.company_from || "\u2014"}</div>
                <div><span className="text-gray-500">Purpose:</span> {result.purpose || "\u2014"}</div>
                <div><span className="text-gray-500">Meeting:</span> {result.whom_to_meet || "\u2014"}</div>
                <div><span className="text-gray-500">In Time:</span> {result.in_time ? formatDateTimeIST(result.in_time) : "\u2014"}</div>
                <div><span className="text-gray-500">Status:</span> <span className={`status-${result.status} px-2 py-0.5 rounded text-xs font-semibold`}>{result.status?.replace("_", " ")}</span></div>
              </div>
            </div>
            {result.status === "checked_in" ? (
              <Button onClick={onCheckout} className="w-full h-12 bg-emerald-600 hover:bg-emerald-700 text-base font-bold" data-testid="confirm-qr-checkout-btn">
                <CheckOutIcon size={18} className="mr-2" /> Confirm Checkout
              </Button>
            ) : (
              <div className="text-center p-3 bg-gray-100 rounded text-sm text-gray-600">
                This visitor is already <strong>{result.status?.replace("_", " ")}</strong>.
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
